import { render, staticRenderFns } from "./RelatedTasksTab.vue?vue&type=template&id=05438fd4&scoped=true&"
import script from "./RelatedTasksTab.vue?vue&type=script&lang=js&"
export * from "./RelatedTasksTab.vue?vue&type=script&lang=js&"
import style0 from "./RelatedTasksTab.vue?vue&type=style&index=0&id=05438fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05438fd4",
  null
  
)

export default component.exports